/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from 'api';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import Page from 'components/Page';
import { urlCertificados } from 'constants/urls';
import useCustomRouter from 'hooks/useCustomRouter';
import React, { useCallback, useEffect } from 'react';
import { useParams } from 'react-router';
import useDetallePoliza from 'redux/hooks/useDetallePoliza';
import Loading from 'wrappers/Loading';
import HistorialCertificadosEmitidosPoliza from './components/HistorialCertificadosEmitidosPoliza';
import InformacionPoliza from './components/InformacionPoliza';

const DetalleCertificados = () => {
  const { idPoliza, codPlan } = useParams();

  const {
    setCertificadosProps,
    loading,
    setPlanSeleccionado,
    setLoading,
    setStateDetallePoliza,
    poliza,
  } = useDetallePoliza();

  const router = useCustomRouter();
  const init = useCallback(async () => {
    const Data = {
      id: idPoliza,
      codPlan,
    };

    setLoading(true);

    const res = await consumirServicioEncirptacion(urlCertificados, Data);
    console.log('RES: ', res);
    if (res?.transaccion) {
      setCertificadosProps(res);
      setStateDetallePoliza(res?.poliza);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    setPlanSeleccionado(
      poliza.polItems?.find((item) => item?.planCodigo === codPlan),
    );
  }, [poliza]);

  useEffect(() => {
    init();
  }, [init]);

  return (
    <Loading loading={loading}>
      <main className="cr-content">
        <Page>
          <BreadCurmb title="Detalle de compra" subtitle="Detalle de compra" />

          <button
            className="btn btn-sm btn-primary"
            onClick={() => {
              router.push(`/detalle-poliza/${idPoliza}`);
              setPlanSeleccionado(null);
            }}
          >
            Regresar
          </button>

          <InformacionPoliza />
          <HistorialCertificadosEmitidosPoliza />
        </Page>
      </main>
    </Loading>
  );
};

export default DetalleCertificados;
